// Collection Types
export const REFERENCE_COLLECTIONS = {
  actionMode: "GActionMode",
  agSector: "GAgSector",
  chemicalGroup: "GChemicalGroup",
  genusSpecies: "GGenusSpecies",
  mainEndUse: "GMainEndUse",
  manufacturer: "GManufacturer",
  moaGroup: "GMoaGroup",
  parameter: "GParameter",
  productGrade: "GProductGrade",
  productGroup: "GProductGroup",
  physicalState: "GPhysicalState",
  segment: "GSegment",
  speciesType: "GSpeciesType",
  techStack: "GTechStack",
  unit: "GUnit",
};

export const REGULAR_COLLECTIONS = {
  applicationMethod: "GApplicationMethod",
  biostimulant: "GBiostimulant",
  constraint: "GConstraint",
  operation: "GOperation",
  plantProduction: "GPlantProduction",
  plantProtection: "GPlantProtection",
  seedSpecies: "GSeedSpecies",
  soilInput: "GSoilInput",
  supplier: "GSupplier",
  timing: "GTiming",
};

// Collection names
export const ACTIONMODE_COLLECTION = "actionMode";
export const AGSECTOR_COLLECTION = "agSector";
export const APPLICATIONMETHOD_COLLECTION = "applicationMethod";
export const BIOSTIMULANT_COLLECTION = "biostimulant";
export const CHEMICALGROUP_COLLECTION = "chemicalGroup";
export const CONSTRAINT_COLLECTION = "constraint";
export const GENUSSPECIES_COLLECTION = "genusSpecies";
export const MAINENDUSE_COLLECTION = "mainEndUse";
export const MANUFACTURER_COLLECTION = "manufacturer";
export const MOAGROUP_COLLECTION = "moaGroup";
export const OPERATION_COLLECTION = "operation";
export const ORGANISATION_COLLECTION = "organisation";
export const PARAMETER_COLLECTION = "parameter";
export const PLANTPRODUCTION_COLLECTION = "plantProduction";
export const PLANTPROTECTION_COLLECTION = "plantProtection";
export const PRODUCTGRADE_COLLECTION = "productGrade";
export const PRODUCTGROUP_COLLECTION = "productGroup";
export const PHYSICALSTATE_COLLECTION = "physicalState";
export const SEEDSPECIES_COLLECTION = "seedSpecies";
export const SEGMENT_COLLECTION = "segment";
export const SOILINPUT_COLLECTION = "soilInput";
export const SPECIESTYPE_COLLECTION = "speciesType";
export const SUPPLIER_COLLECTION = "supplier";
export const TECHSTACK_COLLECTION = "techStack";
export const TIMING_COLLECTION = "timing";
export const UNIT_COLLECTION = "unit";

// Step-picker-only browse keys for the useWater-scoped views (and the seed
// treatment product-group view) over GPlantProtection (OP-2420, OP-2401). Not Global Catalogue collections — do not add
// them to REGULAR_COLLECTIONS or the GC collection lists.
export const CHEMICAL_COLLECTION = "chemical";
export const ADJUVANT_COLLECTION = "adjuvant";
export const SEED_TREATMENT_COLLECTION = "seedTreatment";

// Product group the API scopes the seed treatment views to (appsettings
// AppSettings:SeedTreatmentProductGroup). MSearch has no seed treatment route,
// so the Seed Treatment tab search filters GPlantProtection by this name.
export const SEED_TREATMENT_PRODUCT_GROUP_NAME = "Mixed Function Seed Treat";

// Collections having submenus in side navigation
export const COLLECTIONS_WITH_SUBMENUS = [OPERATION_COLLECTION];

export const COLLECTIONS_WITH_CREATE_FUNCTIONALITY = [
  BIOSTIMULANT_COLLECTION,
  CONSTRAINT_COLLECTION,
  OPERATION_COLLECTION,
  PLANTPRODUCTION_COLLECTION,
  PLANTPROTECTION_COLLECTION,
  SEEDSPECIES_COLLECTION,
  SOILINPUT_COLLECTION,
];

// Collection config file paths
export const GACTIONMODE_COLLECTION_CONFIG_URL =
  "/config/GActionModeCollectionConfig.json";
export const GAGSECTOR_COLLECTION_CONFIG_URL =
  "/config/GAgSectorCollectionConfig.json";
export const GAPPLICATIONMETHOD_COLLECTION_CONFIG_URL =
  "/config/GApplicationMethodCollectionConfig.json";
export const GBIOSTIMULANT_COLLECTION_CONFIG_URL =
  "/config/GBiostimulantCollectionConfig.json";
export const GCHEMICALGROUP_COLLECTION_CONFIG_URL =
  "/config/GChemicalGroupCollectionConfig.json";
export const GCONSTRAINT_COLLECTION_CONFIG_URL =
  "/config/GConstraintCollectionConfig.json";
export const GOPERATION_COLLECTION_CONFIG_URL =
  "/config/GOperationCollectionConfig.json";
export const GMAINENDUSE_COLLECTION_CONFIG_URL =
  "/config/GMainEndUseCollectionConfig.json";
export const GMANUFACTURER_COLLECTION_CONFIG_URL =
  "/config/GManufacturerCollectionConfig.json";
export const GPARAMETER_COLLECTION_CONFIG_URL =
  "/config/GParameterCollectionConfig.json";
export const GPLANTPRODUCTION_COLLECTION_CONFIG_URL =
  "/config/GPlantProductionCollectionConfig.json";
export const GPLANTPROTECTION_COLLECTION_CONFIG_URL =
  "/config/GPlantProtectionCollectionConfig.json";
export const GPRODUCTGRADE_COLLECTION_CONFIG_URL =
  "/config/GProductGradeCollectionConfig.json";
export const GPRODUCTGROUP_COLLECTION_CONFIG_URL =
  "/config/GProductGroupCollectionConfig.json";
export const GSEEDSPECIES_COLLECTION_CONFIG_URL =
  "/config/GSeedSpeciesCollectionConfig.json";
export const GSEGMENT_COLLECTION_CONFIG_URL =
  "/config/GSegmentCollectionConfig.json";
export const GSOILINPUT_COLLECTION_CONFIG_URL =
  "/config/GSoilInputCollectionConfig.json";
export const GSUPPLIER_COLLECTION_CONFIG_URL =
  "/config/GSupplierCollectionConfig.json";
export const GTIMING_COLLECTION_CONFIG_URL =
  "/config/GTimingCollectionConfig.json";
export const GUNIT_COLLECTION_CONFIG_URL = "/config/GUnitCollectionConfig.json";

// Collection dataIndex field names
export const ACTIONMODEID_DATA_INDEX = "actionModeId";
export const ACTIVECONSTITUENTS_DATA_INDEX = "activeConstituents";
export const ACTIVEUNIT_DATA_INDEX = "activeUnit";
export const AGSECTORID_DATA_INDEX = "agSectorId";
export const ATTRIBUTES_DATA_INDEX = "attributes";
export const ATTRUNIT_DATA_INDEX = "attrUnit";
export const CATEGORY_DATA_INDEX = "category";
export const CHEMICALGROUPID_DATA_INDEX = "chemicalGroupId";
export const CO2E_UNIT_DATA_INDEX = "co2eUnit";
export const CONCENTRATION_UNIT_DATA_INDEX = "concentrationUnit";
export const CROP_DATA_INDEX = "crop";
export const CROPID_DATA_INDEX = "cropId";
export const GENUSSPECIESID_DATA_INDEX = "genusSpeciesId";
export const LABELDATE_DATA_INDEX = "labelDate";
export const LABELID_DATA_INDEX = "labelId";
export const LABELNAME_DATA_INDEX = "labelName";
export const LABELS_DATA_INDEX = "labels";
export const LABELURL_DATA_INDEX = "labelUrl";
export const MAINENDUSEID_DATA_INDEX = "mainEndUseId";
export const MANUFACTURERID_DATA_INDEX = "manufacturerId";
export const MOAGROUPID_DATA_INDEX = "moaGroupId";
export const OPERATION_UNIT_DATA_INDEX = "operationUnit";
export const PACKSIZEUNIT_DATA_INDEX = "packSizeUnit";
export const PERIODTYPE_DATA_INDEX = "periodType";
export const PERIOD_DATA_INDEX = "period";
export const PHYSICALSTATEID_DATA_INDEX = "physicalStateId";
export const PRODUCTGRADEID_DATA_INDEX = "productGradeId";
export const PRODUCTGROUPS_DATA_INDEX = "productGroups";
export const PRODUCTUNIT_DATA_INDEX = "productUnit";
export const RAINFAST_UNIT_DATA_INDEX = "rainfastUnit";
export const RATE_UNIT_DATA_INDEX = "rateUnit";
export const REENTRY_UNIT_DATA_INDEX = "reentryUnit";
export const SEGMENT_DATA_INDEX = "segments";
export const SNAPACTIONMODE_DATA_INDEX = "snapActionMode";
export const SNAPAGSECTOR_DATA_INDEX = "snapAgSector";
export const SNAPCHEMICALGROUP_DATA_INDEX = "snapChemicalGroup";
export const SNAPCROPNAME_DATA_INDEX = "snapCropName";
export const SNAPGENUSSPECIES_DATA_INDEX = "snapGenusSpecies";
export const SNAPMAINENDUSE_DATA_INDEX = "snapMainEndUse";
export const SNAPMANUFACTURER_DATA_INDEX = "snapManufacturer";
export const SNAPPHYSICALSTATE_DATA_INDEX = "snapPhysicalState";
export const SNAPPRODUCTGRADE_DATA_INDEX = "snapProductGrade";
export const SNAPMOAGROUP_DATA_INDEX = "snapMoaGroup";
export const SNAPSPECIESTYPE_DATA_INDEX = "snapSpeciesType";
export const SNAPSUPPLIER_DATA_INDEX = "snapSupplier";
export const SNAPTECHSTACK_DATA_INDEX = "snapTechStack";
export const SPECIESTYPEID_DATA_INDEX = "speciesTypeId";
export const SPECWITHHOLDPERIODS_DATA_INDEX = "specWithholdPeriods";
export const SUPPLIERID_DATA_INDEX = "supplierId";
export const TECHSTACKID_DATA_INDEX = "techStackId";
export const VARIETIES_DATA_INDEX = "varieties";
export const VARIETYID_DATA_INDEX = "varietyId";

// Collection filter / search config
export const COLLECTION_FILTER_TYPES = {
  MANUFACTURER: "manufacturer",
} as const;

export const COLLECTION_FILTERS: Record<
  string,
  (typeof COLLECTION_FILTER_TYPES)[keyof typeof COLLECTION_FILTER_TYPES][]
> = {
  biostimulant: [COLLECTION_FILTER_TYPES.MANUFACTURER],
  plantProtection: [COLLECTION_FILTER_TYPES.MANUFACTURER],
  soilInput: [COLLECTION_FILTER_TYPES.MANUFACTURER],
  seedSpecies: [COLLECTION_FILTER_TYPES.MANUFACTURER],
};

export const API_SEARCHABLE_COLLECTIONS = {
  biostimulant: "GBiostimulant",
  constraint: "GConstraint",
  plantProtection: "GPlantProtection",
  soilInput: "GSoilInput",
  seedSpecies: "GSeedSpecies",
  operation: "GOperation",
  timing: "GTiming",
  manufacturer: "GManufacturer",
};

export const SEARCHABLE_DROPDOWN_DATA_INDEXES = [
  MANUFACTURERID_DATA_INDEX,
  MOAGROUPID_DATA_INDEX,
  SPECIESTYPEID_DATA_INDEX,
  SUPPLIERID_DATA_INDEX,
];

export const COLLECTION_SEARCH_FIELDS = {
  biostimulant: ["name"],
  constraint: ["name"],
  plantProtection: ["name"],
  soilInput: ["name"],
  seedSpecies: ["name", "varieties.varietyName"],
  operation: ["name"],
  timing: ["name"],
  manufacturer: ["name"],
};

export const COLLECTION_FILTER_FIELDS = {
  biostimulant: { manufacturer: "manufacturerId" },
  plantProtection: { manufacturer: "manufacturerId" },
  soilInput: { manufacturer: "manufacturerId" },
  seedSpecies: { manufacturer: "varieties.manufacturerId" },
};

export const DEFAULT_SEARCH_PLACEHOLDER = "Search by name";

export const COLLECTION_SEARCH_PLACEHOLDERS = {
  seedSpecies: "Search by crop or variety name",
};

export const LIST_ITEM_TITLE_FIELD_MAPPING: Record<string, string> = {
  [ACTIVECONSTITUENTS_DATA_INDEX]: "name",
  [ATTRIBUTES_DATA_INDEX]: "attrName",
  [VARIETIES_DATA_INDEX]: "varietyName",
  [LABELS_DATA_INDEX]: "labelName",
};

export const WITHHOLD_PERIOD_LABELS = [
  { valueKey: "withholdPeriodGrazing", item: "Withholding Grazing" },
  { valueKey: "withholdPeriodCutting", item: "Withholding Cutting" },
  { valueKey: "withholdPeriodHarvest", item: "Withholding Harvest" },
  { valueKey: "withholdPeriodPlantback", item: "Withholding Plantback" },
] as const;

// GC — field attribute names
export const IS_BASE_UNIT = "isBaseUnit";
export const IS_ACTIVE = "isActive";
export const CATEGORY_VALUES = [0, 1, 2, 4, 8, 16, 32];
export const MULTIPLIER = "multiplier";
export const PARAMETERID = "parameterId";
export const SNAPPARAMETER = "snapParameter";

// GC — parameter / unit names (matched against GParameter.name and GUnit.code)
export const AREA_PARAMETER_NAME = "Area";
export const CARBON_EMISSION = "Carbon Emissions";
export const PLANTPRODUCTION_LARGE_SOLID = "Plant Production - Large Solid";
export const PLANTPRODUCTION_LARGE_LIQUID = "Plant Production - Large Liquid";
export const PLANTPROTECTION_SMALL_SOLID = "Plant Protection - Small Solid";
export const PLANTPROTECTION_SMALL_LIQUID = "Plant Protection - Small Liquid";
export const PLANTPROTECTION_LARGE_SOLID = "Plant Protection - Large Solid";
export const PLANTPROTECTION_LARGE_LIQUID = "Plant Protection - Large Liquid";
export const SOILINPUT_SMALL_SOLID = "Soil Input - Small Solid";
export const SOILINPUT_SMALL_LIQUID = "Soil Input - Small Liquid";
export const WEIGHT = "Weight";
export const KG = "kg";
export const REENTRY_TIME = "Reentry Time";
export const RAINFAST_TIME = "Rainfast Time";
export const HA_UNIT_CODE = "$/ha";
export const TONNE_UNIT_CODE = "t";

// GC — access role and form prefix
export const GC_EDITOR_ROLE = "GcEditor";
export const GC_COLLECTION_CREATE_FORM_PREFIX = "gc_collection_create_form:";
